// extracted by mini-css-extract-plugin
export default {"alert":"monitor_alert__Zyquw","divider":"monitor_divider__ha+Ce"};